module.exports = __webpack_public_path__ + "static/media/nblur.e68c1e6f.svg";